<template>
  <div class="manager-field">
    <VSearchSelect
        class="manager-field__select"
        :placeholder="placeholder"
        :items="itemOptions"
        :error="props.error"
        :loading="loading"
        errorMessage="Заполните обязательное поле"
        @selectItem="onSelectResponsibleHr"
        @input="debouncedSearchResponsible"
        v-model="searchResponsibleHr"
    />
  </div>
</template>
<script setup>
import {computed, onMounted, ref, watch} from "vue";
import {debounce} from "@/services/helpers";
import common from "@/api/common";
import externalIntegrations from "@/api/externalIntegrations";
const props = defineProps({
  modelValue: [String, Number],
  error: Boolean,
  placeholder: String,
  disabled: Array,
  itegrationType: String,
})
const emit = defineEmits(["update:modelValue"]);
const searchResponsibleHr = ref('')
const responsibleHrOptions = ref([])

const debouncedSearchResponsible = debounce(() => searchResponsible(), 400);
const searchResponsible = async () => {
  if (!searchResponsibleHr.value) {
    emit('update:modelValue', null)
    searchResponsibleHr.value = '';
  }
};

const loading = ref(true);

const onSelectResponsibleHr = (item) => {
  emit('update:modelValue', item?.id)
  searchResponsibleHr.value = item?.title;
};

const itemOptions = computed(() => {
  let data =  responsibleHrOptions.value.map((el) => {
    return ({...el,
      name: el.title + ' (' + el.address  + ')',
      subTitle: el.address,
      disable: el.already_used ||  false})
    // props.disabled.includes(el?.id) ||
  })
  if (data?.length < 1) {
    data = false
  }
  return data
})

watch(() => searchResponsibleHr.value, async () => {
  let options = []

    if (props.itegrationType === 'avito') {
      options = await externalIntegrations.getAvitoVacanciesListAvito(searchResponsibleHr.value);
    }
    if (props.itegrationType === 'hh') {
      options = await externalIntegrations.getAvitoVacanciesListHeadHunter(searchResponsibleHr.value);
    }
    if(options?.vacancies) {
      responsibleHrOptions.value = options?.vacancies
      loading.value = false
    }

})

onMounted(async () => {
  let options = []
  if (props.itegrationType === 'avito') {
    options = await externalIntegrations.getAvitoVacanciesListAvito(searchResponsibleHr.value);
  }
  if (props.itegrationType === 'hh') {
    options = await externalIntegrations.getAvitoVacanciesListHeadHunter(searchResponsibleHr.value);
  }
  if(options?.vacancies) {
    responsibleHrOptions.value = options?.vacancies
    loading.value = false
  }

})
</script>
<style scoped lang="scss">
.manager-field {
  &__select {
    width: 100%;

    :deep(.v-select__header) {
      height: 40px;
    }


    :deep(.v-select__header-value) {
      top: 12px;
      padding-right: 20px;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow-x: hidden;
      font-weight: 500;
    }
    :deep(.v-select__header_selected) {
      .v-select__header-palceholder {
        top: 2px;
        display: none;
      }
    }
    :deep(.v-select__header-palceholder) {
      color: $gray;
    }
    :deep(.v-input__placeholder) {
      color: $gray;
    }
  }

  &__form-field-error {
    margin-top: 16px;
    font-size: 14px;
    color: $red;
  }
}
</style>